import MuiAccordion from '@mui/material/Accordion';
import { styled } from '@mui/system';

const Accordion = styled(MuiAccordion)({
  '&.MuiAccordion-root': {
    border: '1px solid rgba(255, 255, 255, .125)',
    boxShadow: 'none',
    '&:not(:last-child)': {
      borderBottom: 0,
    },
    '&:before': {
      display: 'none',
    },
    '&.Mui-expanded': {
      margin: 'auto',
    },
  },
});

export default Accordion;
